export const CREATE_SENDING_DOMAIN = 'createSendingDomain';
export const DELETE_SENDING_DOMAIN = 'deleteSendingDomain';
export const SET_TRACKING_DOMAIN = 'setTrackingDomain';
export const VERIFY_SENDING_DOMAIN = 'verifySendingDomain';

export const CREATE_TRACKING_DOMAIN = 'createTrackingDomain';
export const SET_DEFAULT_TRACKING_DOMAIN = 'editTrackingDomain';
export const DELETE_TRACKING_DOMAIN = 'deleteTrackingDomain';

export const CREATE_TRACKING_DOMAIN_PATH = 'createTrackingDomainPath';
export const ENABLE_TRACKING_DOMAIN_PATH = 'enableTrackingDomainPath';

export const DEFAULT_ERROR = 'Please try again later. If the problem persists, contact your CSM.';

export const INVALID_DOMAINS_ERROR =
  'Provide a valid domain name (for example, links.example.com or example.com)';

export const DOMAIN_EXISTS_ERROR = 'Domain already exists.';

export const TRACKING_DOMAIN_ERROR = `Could not disable the top level tracking domain. ${DEFAULT_ERROR}`;

export const BREADCRUMB = (isLinkShorteningTurnedOn = false) => ({
  content: isLinkShorteningTurnedOn ? 'Domains' : 'Mail domains',
  href: '/settings/domains',
});

export const HTTPS_DISABLED_TOOLTIP = 'HTTPS must be enabled for deep links to be enabled';
export const LEGACY_PATH_DISABLED_TOOLTIP =
  'Legacy destination domains can not be updated. They may still be enabled or disabled.';

export const TRACKING_HTTPS_SUCCESS =
  'Succesfully updated the https setting for this tracking domain.';
export const TRACKING_HTTPS_ERROR = (
  <span>
    Could not verify HTTPS proxy setup. Please refer to this{' '}
    <a
      href="https://support.iterable.com/hc/en-us/articles/115000427446-How-to-set-up-HTTPS-for-link-click-tracking"
      title="How to set up HTTPS for link click tracking"
    >
      support article
    </a>{' '}
    or contact{' '}
    <a href="mailto:support@iterable.com" title="support@iterable.com">
      support@iterable.com
    </a>
  </span>
);

// used to show the aasa in the path section
export const EMPTY_AASA = {
  apps: [],
  details: [],
};

// used in CreateDeepLInkPathModal to create a new empty path
export const EMPTY_APPLINKS_JSON = JSON.stringify({
  applinks: EMPTY_AASA,
});
